import { render } from "./Header_m.vue?vue&type=template&id=588c2c96"
import script from "./Header_m.vue?vue&type=script&lang=js"
export * from "./Header_m.vue?vue&type=script&lang=js"

import "./Header_m.vue?vue&type=style&index=0&id=588c2c96&lang=css"
script.render = render

export default script